import { observer, inject } from "mobx-react";
import styled from "styled-components";
import menuItemImg from "../../assets/img/menu-item.svg";
import menuItemImg1 from "../../assets/img/menu-item1.svg";
import logout from "../../assets/img/logout.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const StyledItem = styled("li")`
  color: #ffffff;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const Sidebar = ({ userStore, onClose }) => {
  const { t } = useTranslation("deliveryOrder");
  const navigate = useNavigate();

  const exitApp = () => {
    userStore.appLogout();
    onClose();
    navigate("/delivery_order/login");
  };
  return (
    <nav
      style={{
        color: "#ffffff",
        display: "flex",
        flexDirection: "column",
        height: "100dvh", // new iOS-safe height
      }}
    >
      <ul
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          listStyle: "none",
          padding: "60px 0",
          margin: 0,
          gap: 30,
        }}
      >
        <StyledItem
          onClick={() => {
            onClose();
            navigate("/delivery_order/frameList");
          }}
        >
          <img src={menuItemImg} alt="frames" />
          {t("frames_list_page")}
        </StyledItem>
        <StyledItem
          onClick={() => {
            onClose();
            navigate("/delivery_order/ordersList");
          }}
        >
          <img src={menuItemImg1} alt="orders" />
          {t("orders_list_page")}
        </StyledItem>
        <StyledItem onClick={exitApp} style={{ marginTop: "auto" }}>
          <img src={logout} alt="logout" />
          {t("exit")}
        </StyledItem>
      </ul>
    </nav>
  );
};

export default inject("userStore")(observer(Sidebar));
